export default "__VITE_ASSET__Bknpp1C9__"